'use client';

import { c as _c } from "react/compiler-runtime";
import Pusher from 'pusher-js';
import { createContext, useContext } from 'react';
import { z } from 'zod';
export const PusherContext = createContext({});
export const AUTH_ENDPOINT = `${process.env.NEXT_PUBLIC_BACKEND_URL}/broadcasting/auth`;
export const PUSHER_APP_KEY = process.env.NEXT_PUBLIC_PUSHER_APP_KEY;
export const PUSHER_WS_HOST = process.env.NEXT_PUBLIC_PUSHER_WS_HOST;
export const PUSHER_WS_PORT = process.env.NEXT_PUBLIC_PUSHER_WS_PORT;
export const PUSHER_CLUSTER = process.env.NEXT_PUBLIC_PUSHER_CLUSTER;
export const PusherProvider = t0 => {
  const $ = _c(7);
  const {
    accessToken,
    children
  } = t0;
  const t1 = `Bearer ${accessToken}`;
  let t2;
  if ($[0] !== t1) {
    t2 = new Pusher(PUSHER_APP_KEY, {
      auth: {
        headers: {
          Authorization: t1
        }
      },
      authEndpoint: AUTH_ENDPOINT,
      cluster: PUSHER_CLUSTER,
      disableStats: false,
      enabledTransports: ["ws"],
      forceTLS: false,
      wsHost: PUSHER_WS_HOST,
      wsPort: PUSHER_WS_PORT ? z.coerce.number().optional().parse(PUSHER_WS_PORT) : undefined
    });
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const pusher = t2;
  let t3;
  if ($[2] !== pusher) {
    t3 = {
      pusher
    };
    $[2] = pusher;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== children || $[5] !== t3) {
    t4 = <PusherContext.Provider value={t3}>{children}</PusherContext.Provider>;
    $[4] = children;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export const usePusher = () => {
  const context = useContext(PusherContext);
  if (!context) {
    throw new Error("usePusher must be used within a PusherProvider");
  }
  return context;
};